import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './divider.styles';

const Divider = ({ label }) => {
  const classes = useStyles();

  if (label) {
    return (
      <div className={classes.divider}>
        <span className={classes.label}>{label}</span>
      </div>
    );
  }

  return <div className={classes.divider} />;
};

Divider.propTypes = {
  label: PropTypes.string
};

export default Divider;
